import { render } from "./InvoicesAnalytics.vue?vue&type=template&id=525bb530"
import script from "./InvoicesAnalytics.vue?vue&type=script&lang=js"
export * from "./InvoicesAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__